import React from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
export function BonosSection() {
  const bonos = [{
    id: '01',
    emoji: '📝',
    title: 'Banco de Actividades y Ejercicios Nucleares',
    desc: 'Más de 120 actividades listas para usar: individuales, grupales, debates sobre política energética, simulaciones de reacciones en cadena, análisis de datos de Atucha y Embalse, datación arqueológica argentina.',
    value: '$18.000'
  }, {
    id: '02',
    emoji: '🌍',
    title: 'Casos de Estudio Completos',
    desc: 'Ocho casos de estudio con análisis técnico, histórico y pedagógico completo: Chernóbil (1986), Fukushima (2011), Three Mile Island (1979), el RA-1 como primer reactor de América Latina, INVAP y el reactor OPAL en Australia.',
    value: '$15.000'
  }, {
    id: '03',
    emoji: '📊',
    title: 'Infografías y Esquemas HD',
    desc: '40 infografías y esquemas de alta calidad listos para proyectar en el aula o imprimir en A3: la escala del átomo, los tres tipos de radiación, la curva de energía de enlace, el flujo de energía del reactor al enchufe.',
    value: '$20.000'
  }, {
    id: '04',
    emoji: '📋',
    title: 'Evaluaciones y Trabajos Prácticos',
    desc: '25 instrumentos de evaluación completos con rúbricas incluidas: evaluaciones diagnósticas, formativas y sumativas para todos los niveles, trabajos prácticos y proyectos integradores.',
    value: '$15.000'
  }, {
    id: '05',
    emoji: '📘',
    title: 'Guía Didáctica Completa para el Docente',
    desc: 'El manual pedagógico que ningún libro de física nuclear incluye: marco filosófico para enseñar temas socialmente sensibles, perfil y autoevaluación del docente nuclear, tres planificaciones anuales completas.',
    value: '$12.000'
  }];
  return <section className="py-20 bg-surface text-white relative overflow-hidden" data-id="element-20">
      {/* Background decoration */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-electric/10 rounded-full blur-3xl" data-id="element-21"></div>
      <div className="absolute bottom-0 left-0 w-64 h-64 bg-neon/10 rounded-full blur-3xl" data-id="element-22"></div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-23">
        <div className="text-center mb-16" data-id="element-24">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-neon/20 text-neon mb-6" data-id="element-25">
            <Gift className="w-8 h-8" data-id="element-26" />
          </div>
          <h2 className="text-3xl md:text-4xl font-extrabold mb-4" data-id="element-27">
            🎁 5 BONOS ESTRATÉGICOS
          </h2>
          <p className="text-xl text-neon font-bold" data-id="element-28">SIEMPRE INCLUIDOS</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-5xl mx-auto" data-id="element-29">
          {bonos.map((bono, i) => <motion.div key={bono.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className={`bg-base border border-surface rounded-2xl p-6 flex flex-col h-full relative overflow-hidden group hover:border-neon/50 transition-colors ${i === 4 ? 'md:col-span-2 md:w-1/2 md:mx-auto' : ''}`} data-id="element-30">
              <div className="absolute top-0 right-0 bg-surface text-neon text-xs font-bold px-3 py-1 rounded-bl-lg" data-id="element-31">
                Bono {bono.id}
              </div>

              <div className="flex items-start gap-4 mb-4 mt-2" data-id="element-32">
                <div className="text-4xl" data-id="element-33">{bono.emoji}</div>
                <div data-id="element-34">
                  <h3 className="text-xl font-bold text-white leading-tight mb-2" data-id="element-35">
                    {bono.title}
                  </h3>
                  <p className="text-muted text-sm leading-relaxed" data-id="element-36">
                    {bono.desc}
                  </p>
                </div>
              </div>

              <div className="mt-auto pt-4 border-t border-surface flex items-center justify-between" data-id="element-37">
                <span className="text-slate-500 line-through text-sm" data-id="element-38">
                  Valor {bono.value}
                </span>
                <span className="text-neon font-black tracking-wide" data-id="element-39">
                  GRATIS
                </span>
              </div>
            </motion.div>)}
        </div>

        <div className="mt-12 text-center" data-id="element-40">
          <div className="inline-block bg-white/10 backdrop-blur-sm border border-white/20 rounded-xl px-8 py-4" data-id="element-41">
            <p className="text-lg" data-id="element-42">
              Valor total bonos{' '}
              <span className="line-through opacity-50" data-id="element-43">$80.000 ARS</span>{' '}
              <span className="text-neon font-bold mx-2" data-id="element-44">→</span>{' '}
              <span className="font-black text-xl" data-id="element-45">GRATIS con tu Megapack</span>
            </p>
          </div>
        </div>
      </div>
    </section>;
}